import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FabricCategory } from '../../models/fabric/fabricCategory';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class FabricCategoryProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/fabric-categories';

  public getFabricCategories(): Observable<ApiResponse<FabricCategory[]>> {
    return this.httpClient.get<ApiResponse<FabricCategory[]>>(`${this.baseUrl}/all`);
  }

  public createFabricCategory(category: FabricCategory): Observable<ApiResponse<FabricCategory>> {
    return this.httpClient.post<ApiResponse<FabricCategory>>(this.baseUrl, category);
  }

  public updateFabricCategory(id: string, fabricCategory: FabricCategory): Observable<ApiResponse<FabricCategory>> {
    return this.httpClient.put<ApiResponse<FabricCategory>>(`${this.baseUrl}/${id}`, fabricCategory);
  }

  public deleteFabricCategoryById(id: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
